import auth0 from 'auth0-js';
import authConfig from '../../auth_config.json';

let config;

if (process.env.NODE_ENV === 'production' && window.auth0Config) {
  config = window.auth0Config;
  config = Object.assign({
    overrides: {
      __tenant: config.auth0Tenant,
      __token_issuer: config.authorizationServer.issuer
    },
    domain: config.auth0Domain,
    clientID: config.clientID,
    redirectUri: config.callbackURL,
    responseType: 'code'
  }, config.internalOptions);
} else {
  config = {
    overrides: {
      __tenant: 'dev-29hrefs7',
      __token_issuer: 'https://login.oniudra.cc/'
    },
    domain: authConfig.domain,
    redirectUri: `https://cdn-stag.arduino.cc/header-footer/test_en.html`,
    clientID: authConfig.clientId,
    responseType: 'code'
  };
}

const webAuth = new auth0.WebAuth(config);

const databaseConnection = 'arduino';

class AuthService {
  login (username, password, cb) {
    webAuth.login({
      realm: databaseConnection,
      username,
      password
    }, err => cb(err));
  };

  loginWithGoogle () {
    webAuth.authorize({
      connection: 'google-oauth2'
    }, function (err) {
      // eslint-disable-next-line
      if (err) console.log(err);
    });
  };

  signupAndLogin (userParams, cb) {
    const params = { ...userParams, connection: databaseConnection };
    webAuth.redirect.signupAndLogin(params, err => cb(err));
  };

  resetPasswordRequest (email, cb) {
    const params = { email, connection: databaseConnection };
    webAuth.changePassword(params, (err, resp) => cb(err, resp));
  }
}

const service = new AuthService();

export default service;
